<template>
  <div id="app">
    <div class="picDiv"><img id="me" src="./assets/me.jpg" /></div>
    <h1>Patrick Brown</h1>
    <h2>
      I scream, you scream, we all scream for beautiful, usable, and accessible
      websites!
    </h2>
    <p>
      Let's work together to make some fun stuff, and have some laughs along the
      way.
    </p>
    <div class="links">
      <a href="PatrickBrownResume.pdf" target="_blank">Resume</a> &middot;
      <a href="https://www.linkedin.com/in/brownpl/" target="_blank"
        >LinkedIn</a
      >
      &middot;
      <a href="http://github.com/brownpl" target="_blank">Github</a> &middot;
      <a href="mailto:patrick@patrick-brown.com">Email</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-family: "Nunito", sans-serif;
}
a {
  color: #c4083f;
  &:hover {
    text-decoration: underline;
  }
}
h2 {
  max-width: 750px;
  margin: 25px auto;
}
p {
  max-width: 750px;
  margin: 25px auto;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: rgb(248, 217, 198);
  background: linear-gradient(
    28deg,
    rgba(248, 217, 198, 1) 0%,
    rgba(240, 197, 180, 1) 100%
  );
  @media screen and (min-width: 600px) {
    background-image: url("./assets/seattle-sunset.jpg");
    background-size: cover;
  }
  padding-bottom: 200px;
  height: 100vh;
}
.picDiv {
  padding-top: 50px;
}
#me {
  height: 170px;
  border-radius: 90px;
  border: 1px solid #c4083f;
}
h1 {
  background-color: #c4083f;
  color: #ffffff;
  display: inline-block;
  padding: 3px 8px;
  margin: 25px 0 10px;
  font-weight: bold;
  font-size: 22px;
}
</style>
